import { ButtonComponent } from '../components/basic/button/button.component';
import { LinkComponent } from '../components/basic/link/link.component';

export class ControlEvent<TComponent> {
    readonly component: TComponent;

    constructor(component: TComponent) {
        this.component = component;
    }
}

export class ClickEvent<TComponent> extends ControlEvent<TComponent> {
    constructor(component: TComponent) {
        super(component);
    }
}

export class ButtonClickEvent extends ClickEvent<ButtonComponent> {
    constructor(component: ButtonComponent) {
        super(component);
    }
}

export class LinkClickEvent extends ClickEvent<LinkComponent> {
    constructor(component: LinkComponent) {
        super(component);
    }
}
